import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BulletListIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BulletList",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.68 6.39H12.91c-.73 0-1.32.59-1.32 1.32s.59 1.32 1.32 1.32h15.77c.73 0 1.32-.59 1.32-1.32s-.59-1.32-1.32-1.32m-15.77 7h8.76c.73 0 1.32-.59 1.32-1.32s-.59-1.32-1.32-1.32h-8.76c-.73 0-1.32.59-1.32 1.32s.59 1.32 1.32 1.32m8.76 12.24c.73 0 1.32-.59 1.32-1.32s-.59-1.32-1.32-1.32h-8.76c-.73 0-1.32.59-1.32 1.32s.59 1.32 1.32 1.32zm7.01-6.99H12.91c-.73 0-1.32.59-1.32 1.32s.59 1.32 1.32 1.32h15.77c.73 0 1.32-.59 1.32-1.32s-.59-1.32-1.32-1.32M8.98 9.86c0 1.93-1.56 3.49-3.49 3.49S2 11.79 2 9.86s1.56-3.49 3.49-3.49 3.49 1.56 3.49 3.49m0 12.27c0 1.93-1.56 3.49-3.49 3.49S2 24.06 2 22.13s1.56-3.49 3.49-3.49 3.49 1.56 3.49 3.49"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27 8H15c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1M21 13h-6c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1M27 21H15c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1M21 26h-6c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1M7.5 12a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 0 0 5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.5 13C5.57 13 4 11.43 4 9.5S5.57 6 7.5 6 11 7.57 11 9.5 9.43 13 7.5 13m0-5C6.67 8 6 8.67 6 9.5S6.67 11 7.5 11 9 10.33 9 9.5 8.33 8 7.5 8M7.5 25a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 0 0 5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.5 26C5.57 26 4 24.43 4 22.5S5.57 19 7.5 19s3.5 1.57 3.5 3.5S9.43 26 7.5 26m0-5c-.83 0-1.5.67-1.5 1.5S6.67 24 7.5 24 9 23.33 9 22.5 8.33 21 7.5 21"
      })]
    })
  }));
};